module.exports = __webpack_public_path__ + "resources/img/sp_gamebase.0533fa81601c0848f70f42b3bd4ff24f.png";